__turbopack_context__.v({
  "active": "PartnerCategories-module__xamM4W__active",
  "buttonRowsWrapper": "PartnerCategories-module__xamM4W__buttonRowsWrapper",
  "content": "PartnerCategories-module__xamM4W__content",
  "fadeIn": "PartnerCategories-module__xamM4W__fadeIn",
  "fadeOut": "PartnerCategories-module__xamM4W__fadeOut",
  "left": "PartnerCategories-module__xamM4W__left",
  "right": "PartnerCategories-module__xamM4W__right",
  "root": "PartnerCategories-module__xamM4W__root",
  "scrollButton": "PartnerCategories-module__xamM4W__scrollButton",
});
